<template>
  <div class="more-restaurants-stats">
    <v-progress-linear v-if="loading" indeterminate color="primary" height="2" />

    <v-tabs v-model="tab" background-color="primary" dark>
      <v-tab v-for="item in tabDefs" :key="item.key">
        <v-icon style="margin-right: 7px">{{ item.icon }}</v-icon>
        {{ item.label }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab" :touchless="true">
      <v-tab-item>
        <div class="px-2 mt-2">
          <more-restaurants-companies-chart :orders="orders" />
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="px-2 mt-2">
          <more-restaurants-shifts-chart :orders="orders" />
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="px-2 mt-2">
          <more-restaurants-meals-chart :orders="orders" />
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="px-2 mt-2">
          <more-restaurants-taken-chart :orders="orders" />
        </div>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import reportService from "@/services/report";
import MoreRestaurantsCompaniesChart from "@/components/statistics/more-restaurants/MoreRestaurantsCompaniesChart.vue";
import MoreRestaurantsShiftsChart from "@/components/statistics/more-restaurants/MoreRestaurantsShiftsChart.vue";
import MoreRestaurantsMealsChart from "@/components/statistics/more-restaurants/MoreRestaurantsMealsChart.vue";
import MoreRestaurantsTakenChart from "@/components/statistics/more-restaurants/MoreRestaurantsTakenChart.vue";

export default {
  name: "RestaurantMoreRestaurantsStats",
  components: {
    MoreRestaurantsCompaniesChart,
    MoreRestaurantsShiftsChart,
    MoreRestaurantsMealsChart,
    MoreRestaurantsTakenChart,
  },
  props: {
    date: { type: Array, default: () => [] },
  },
  data() {
    return {
      loading: false,
      orders: [],
      tab: 0,
    };
  },
  computed: {
    tabDefs() {
      return [
        { key: "companies", icon: "mdi-office-building", label: this.$t("companies") },
        { key: "shifts", icon: "mdi-clock-time-four-outline", label: this.$t("orders_by_shift") },
        { key: "meals", icon: "mdi-food", label: this.$t("meals") },
        { key: "taken", icon: "mdi-check-circle-outline", label: this.$t("ordered_taken_meals") },
      ];
    },
  },
  methods: {
    async fetchData() {
      const restaurantId = this.$store.state.restaurant?.id;
      if (!restaurantId || !this.date?.length) return;
      this.loading = true;
      try {
        const from = this.date[0];
        const to = this.date[1] || this.date[0];
        const companies = await reportService.getMoreRestaurantReportsNew(restaurantId, {
          date: from,
          date2: to,
        });
        this.orders = Array.isArray(companies) ? companies : [];
      } catch {
        this.orders = [];
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    date: { handler() { this.fetchData(); }, deep: true },
  },
  created() {
    this.fetchData();
  },
};
</script>

<style scoped>
.more-restaurants-stats ::v-deep .v-tabs-items,
.more-restaurants-stats ::v-deep .v-window__container,
.more-restaurants-stats ::v-deep .v-window-item {
  overflow: visible !important;
}
</style>
